import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import * as api from '../../api/generated';
import { KendoLoading, useAuthentication } from '../../components';
import { Role, statisticsType, StatisticsType } from '../../enums';
import { ShowErrorModal } from '../queueManagement/components/ShowErrorModal';
import NugisStatistics from './nugisStatistics/NugisStatistics';
import PowerBiStatistics from './PowerBiStatistics';

const StatisticsPage = () => {
    const [error, setError] = useState<string | null>(null);
    const [statType, setStatType] = useState<StatisticsType>();
    const { type } = useParams<'type'>();

    const { hasAccess } = useAuthentication();
    const navigate = useNavigate();

    const fetchData = async () => {
        try {
            var type = await api.statistic.getStatisticsType();
            setStatType(type);
        } catch (ex) {
            setError(ex.error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [type]);

    return (
        <>
            {hasAccess(Role.Manager) || hasAccess(Role.Manager) ? (
                statType == statisticsType.PowerBI ? (
                    <PowerBiStatistics></PowerBiStatistics>
                ) : statType === statisticsType.Nugis ? (
                    <NugisStatistics></NugisStatistics>
                ) : (
                    <KendoLoading />
                )
            ) : (
                navigate('/')
            )}
            {error && <ShowErrorModal logout={true} error={error}></ShowErrorModal>}
        </>
    );
};

export default StatisticsPage;
